import {
  BarChart3,
  Box,
  Briefcase,
  Code,
  Database,
  Handshake,
  Palette,
  Settings,
  Shield,
  TrendingUp,
} from "lucide-react";
import { DEPARTMENT_STYLES } from "@/lib/constants";
import { cn } from "@/lib/utils";

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  Code,
  TrendingUp,
  BarChart3,
  Box,
  Database,
  Palette,
  Handshake,
  Shield,
  Settings,
};

interface DepartmentIconProps {
  department: string | null | undefined;
  className?: string;
}

export function DepartmentIcon({ department, className }: DepartmentIconProps) {
  const style = department ? DEPARTMENT_STYLES[department as keyof typeof DEPARTMENT_STYLES] : null;
  const IconComponent = (style ? iconMap[style.icon] : null) || Briefcase;
  const bg = style?.bg ?? "bg-slate-100 dark:bg-slate-800";
  const text = style?.text ?? "text-slate-600 dark:text-slate-400";

  return (
    <div className={cn("flex items-center justify-center w-11 h-11 rounded-xl", bg, className)}>
      <IconComponent className={cn("h-5 w-5", text)} />
    </div>
  );
}
